import React, { useEffect } from 'react';
import {  useDispatch } from 'react-redux';
import Reservations from '../Reservations/Reservation';
import { getReservations } from '../../actions/reservationActions';

function ReservationsPage() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getReservations())
  }, [])

  return (
    <>
      <Reservations />
    </>
  );

}

export default ReservationsPage;


